(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ramair-home-judge-custom"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ra-judge-carousel')) {
  customElements.define('ra-judge-carousel', class extends HTMLElement {
    connectedCallback() {
      this._controller = new AbortController();
      this._userPaused = false; this._hovered = false; this._focused = false;
      const init = () => { if (this.isConnected) this.init(); };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true, signal:this._controller.signal});
      else queueMicrotask(init);
    }
    disconnectedCallback() {
      this._controller?.abort(); this._resize?.disconnect();
      clearTimeout(this._scrollTimer); clearInterval(this._timer); this._timer = null;
      this.querySelector('dialog')?.close();
    }
    readText(node) {
      if (!node) return '';
      const paragraphs = [...node.querySelectorAll('p')];
      return (paragraphs.length ? paragraphs.map(p => p.textContent.trim()).join('\n\n') : node.textContent).replace(/[ \t]+/g, ' ').trim();
    }
    init() {
      const source = this.querySelector('[data-feed]')?.content;
      const cardTemplate = this.querySelector('[data-card]');
      const track = this.querySelector('.ra-jr__track');
      if (!source || !cardTemplate || !track) return;
      const seen = new Set();
      this.reviews = [];
      for (const item of source.querySelectorAll('.jdgm-carousel-item')) {
        const ratingNode = item.querySelector('.jdgm-carousel-item__review-rating');
        const ratingMatch = ratingNode?.getAttribute('aria-label')?.match(/\d+(?:[.,]\d+)?/);
        const rating = ratingMatch ? Number(ratingMatch[0].replace(',', '.')) : ratingNode?.querySelectorAll('.jdgm--on').length;
        const body = this.readText(item.querySelector('.jdgm-carousel-item__review-body'));
        const author = this.readText(item.querySelector('.jdgm-carousel-item__reviewer-name')) || 'Anonymous';
        const title = this.readText(item.querySelector('.jdgm-carousel-item__review-title'));
        const key = item.dataset.reviewId || `${author}|${body}`;
        if (rating !== 5 || !body || seen.has(key)) continue;
        seen.add(key);
        const product = item.querySelector('.jdgm-carousel-item__product');
        let url = null;
        try { const candidate = new URL(product?.getAttribute('href') || '', location.origin); if (candidate.origin === location.origin && /\/products\/[^/]+/.test(candidate.pathname)) url = candidate.href; } catch (_) { /* Invalid source link: omit it. */ }
        this.reviews.push({body, author, title, url, product: url ? this.readText(item.querySelector('.jdgm-carousel-item__product-title')) : ''});
      }
      track.replaceChildren();
      this.reviews.forEach((review, index) => {
        const fragment = cardTemplate.content.cloneNode(true);
        fragment.querySelector('.ra-jr__quote').textContent = review.body;
        fragment.querySelector('.ra-jr__author').textContent = review.author;
        fragment.querySelector('.ra-jr__slide').setAttribute('aria-label', `Review ${index + 1} of ${this.reviews.length}`);
        const read = fragment.querySelector('.ra-jr__read'); read.dataset.index = index; read.setAttribute('aria-label', `Read full review by ${review.author}`);
        const product = fragment.querySelector('.ra-jr__product');
        if (review.url && review.product) { product.textContent = review.product; product.href = review.url; product.hidden = false; }
        track.append(fragment);
      });
      this.querySelector('.ra-jr__empty').hidden = this.reviews.length > 0;
      this.hidden = !this.reviews.length && this.dataset.editor !== 'true';
      const signal = this._controller.signal;
      this.track = track;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.motion.addEventListener('change', () => this.syncAutoplay(), {signal});
      document.addEventListener('visibilitychange', () => this.syncAutoplay(), {signal});
      this.addEventListener('mouseenter', () => { this._hovered = true; this.syncAutoplay(); }, {signal});
      this.addEventListener('mouseleave', () => { this._hovered = false; this.syncAutoplay(); }, {signal});
      this.addEventListener('focusin', event => { this._focused = !event.target.closest('[data-pause]'); this.syncAutoplay(); }, {signal});
      this.addEventListener('focusout', event => { this._focused = this.contains(event.relatedTarget); this.syncAutoplay(); }, {signal});
      track.addEventListener('pointerdown', () => this.stopByUser(), {signal, passive:true});
      track.addEventListener('wheel', () => this.stopByUser(), {signal, passive:true});
      this.querySelector('[data-pause]')?.addEventListener('click', () => { this._userPaused = !this._userPaused; this.syncAutoplay(); }, {signal});
      this.querySelector('[data-prev]').addEventListener('click', () => { this.stopByUser?.(); this.move(-1); }, {signal});
      this.querySelector('[data-next]').addEventListener('click', () => { this.stopByUser?.(); this.move(1); }, {signal});
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault(); this.stopByUser?.();
        if (event.key === 'Home') this.goTo(0);
        else if (event.key === 'End') this.goTo(this.reviews.length - 1);
        else this.move(event.key === 'ArrowLeft' ? -1 : 1);
      }, {signal});
      track.addEventListener('scroll', () => {
        clearTimeout(this._scrollTimer);
        this._scrollTimer = setTimeout(() => this.updateNavigation(), 120);
      }, {signal, passive:true});
      this._resize = new ResizeObserver(() => this.updateNavigation()); this._resize.observe(track);
      document.fonts?.ready.then(() => { if (this.isConnected) this.updateNavigation(); });
      this.updateNavigation();
      const dialog = this.querySelector('dialog');
      this.addEventListener('click', event => {
        const read = event.target.closest('.ra-jr__read');
        if (read && this.contains(read)) this.openReview(Number(read.dataset.index), read);
      }, {signal});
      this.querySelector('.ra-jr__close').addEventListener('click', () => this.closeReview(), {signal});
      dialog.addEventListener('cancel', event => { event.preventDefault(); this.closeReview(); }, {signal});
      dialog.addEventListener('click', event => {
        const bounds = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) this.closeReview();
      }, {signal});
    }
    positions() {
      const first = this.track.firstElementChild?.offsetLeft || 0;
      return [...this.track.children].map(slide => slide.offsetLeft - first);
    }
    activeIndex() {
      const positions = this.positions(); let nearest = 0;
      positions.forEach((left, index) => { if (Math.abs(left - this.track.scrollLeft) < Math.abs(positions[nearest] - this.track.scrollLeft)) nearest = index; });
      return nearest;
    }
    updateNavigation() {
      if (!this.track) return;
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.querySelector('.ra-jr__navigation').hidden = max < 2 || this.reviews.length < 2;
      this.querySelector('[data-prev]').disabled = this.track.scrollLeft < 2;
      this.querySelector('[data-next]').disabled = this.track.scrollLeft >= max - 2;
      const index = this.activeIndex();
      const counter = this.querySelector('.ra-jr__counter');
      if (counter) counter.textContent = `${index + 1} / ${this.reviews.length}`;
      this.querySelector('[data-status]').textContent = this.reviews.length ? `Review ${index + 1} of ${this.reviews.length}` : '';
      this.syncAutoplay();
    }
    goTo(index) {
      const positions = this.positions(); if (!positions.length) return;
      const target = Math.max(0, Math.min(index, positions.length - 1));
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.track.scrollTo({left:Math.min(positions[target], max), behavior:this.motion.matches ? 'auto' : 'smooth'});
      this.updateNavigation();
    }
    move(direction) { this.goTo(this.activeIndex() + direction); }
    stopByUser() { this._userPaused = true; this.syncAutoplay(); }
    syncAutoplay() {
      const enabled = this.dataset.autoplay === 'true' && this.reviews.length > 1 && !this.motion.matches;
      const canRun = enabled && !this._userPaused && !this._hovered && !this._focused && !document.hidden && this.track.scrollWidth > this.track.clientWidth + 2;
      if (!canRun) { clearInterval(this._timer); this._timer = null; }
      else if (!this._timer) {
        this._timer = setInterval(() => {
          if (this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 2) this.goTo(0); else this.move(1);
        }, Math.max(3000, Number(this.dataset.interval) || 6000));
      }
      const pause = this.querySelector('[data-pause]');
      if (pause) {
        pause.disabled = this.motion.matches;
        pause.textContent = this._userPaused ? 'Resume' : 'Pause';
        pause.setAttribute('aria-label', this.motion.matches ? 'Autoplay disabled for reduced motion' : this._userPaused ? 'Resume slideshow' : 'Pause slideshow');
      }
      this.querySelector('[data-status]').setAttribute('aria-live', this._timer ? 'off' : 'polite');
    }
    openReview(index, trigger) {
      const review = this.reviews[index]; if (!review) return;
      this.stopByUser?.();
      this._returnFocus = trigger;
      const dialog = this.querySelector('dialog');
      dialog.querySelector('.ra-jr__dialog-title').textContent = review.title;
      dialog.querySelector('.ra-jr__dialog-title').hidden = !review.title;
      dialog.querySelector('.ra-jr__dialog-text').textContent = review.body;
      dialog.querySelector('.ra-jr__dialog-author').textContent = review.author;
      const product = dialog.querySelector('.ra-jr__dialog-product');
      product.hidden = !(review.url && review.product);
      product.textContent = review.product;
      if (review.url) product.href = review.url; else product.removeAttribute('href');
      dialog.showModal();
      dialog.scrollTop = 0;
    }
    closeReview() {
      this.querySelector('dialog').close();
      if (this._returnFocus?.isConnected) this._returnFocus.focus({preventScroll:true});
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
